<cs-header>
  <cs-header-title>
    {{ LL.editTrainingGoal.title() }}
    <help-icon name="info" helpId="@help:references.training-volume"></help-icon>
  </cs-header-title>
</cs-header>

<cs-content [loading]="loading">
  <cs-item-list>
    <!-- Primary Goal section -->
    <cs-item-group small [title]="LL.editTrainingGoal.primaryGoal()" class="primary-goal-section">
      <div class="section-row">
        <cs-note big>{{ primaryGoalText }}</cs-note>

      </div>
      <cs-button secondary small icon="settings" (click)="handleUpdatePrimaryGoal($event)">
        {{ LL.editTrainingGoal.update() }}
      </cs-button>
    </cs-item-group>

    <!-- Method section -->
    <cs-item-group small [title]="LL.editTrainingGoal.method()" class="method-section">
      <cs-radio-group [(selected)]="form.method" (selectedChange)="onMethodChange()">
        <cs-radio [value]="Method.GrowthMindset" [recommended]="true">
          {{ LL.editTrainingGoal.growthMindset() }}
          <cs-note>{{ LL.editTrainingGoal.growthMindsetDescription() }}</cs-note>
        </cs-radio>
        <cs-radio [value]="Method.FixedTarget">
          {{ LL.editTrainingGoal.fixedTarget() }}
          <cs-note>{{ LL.editTrainingGoal.fixedTargetDescription() }}</cs-note>
        </cs-radio>
      </cs-radio-group>
    </cs-item-group>

    <!-- Target Unit section (only for Fat Loss + Fixed Target) -->
    @if (form.method === Method.FixedTarget && !isMuscleGrowth) {
      <cs-item-group small [title]="LL.editTrainingGoal.targetUnit()" class="target-unit-section"
        >
        <cs-note>{{ LL.editTrainingGoal.targetUnitDescription() }}</cs-note>
        <cs-radio-group inline [(selected)]="form.targetUnit">
          <cs-radio [value]="TargetUnit.Weight">{{ LL.editTrainingGoal.weight() }}</cs-radio>
          <cs-radio [value]="TargetUnit.Bodyfat">{{ LL.editTrainingGoal.bodyFatPercent() }}</cs-radio>
        </cs-radio-group>
      </cs-item-group>
    }

    <!-- Goal Weight input (Fixed Target + Weight) -->
    @if (form.method === Method.FixedTarget && (isMuscleGrowth || form.targetUnit === TargetUnit.Weight)) {
      <cs-item-group small [title]="LL.editTrainingGoal.goalWeight()" class="goal-input-section"
        >
        <cs-item>
          <cs-input-measure type="bodyweight_kg" [(canonValue)]="form.goalWeight_kg"></cs-input-measure>
        </cs-item>
      </cs-item-group>
    }

    <!-- Goal Body Fat input (Fixed Target + Body Fat %) -->
    @if (form.method === Method.FixedTarget && !isMuscleGrowth && form.targetUnit === TargetUnit.Bodyfat) {
      <cs-item-group small [title]="LL.editTrainingGoal.goalBodyFat()" class="goal-input-section"
        >
        <cs-item>
          <cs-input-measure type="bodyfat_pc" [(canonValue)]="form.goalBodyfat_pc"></cs-input-measure>
        </cs-item>
      </cs-item-group>
    }
  </cs-item-list>
</cs-content>

<cs-page-action-buttons [showCancel]="true" (cancel)="handleCancel($event)">
  <cs-button primary medium [label]="LL.common.buttons.save()" (click)="handleSave()"></cs-button>
</cs-page-action-buttons>